import { createActions, createReducer } from 'reduxsauce'

import ConsultaContratoCovidService from '../../servicos/ConsultaContratoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaContratoCovidInicio: [],
    buscaConsultaContratoCovidSucesso: ['consultaContratoCovid'],
    buscaConsultaContratoCovidErro: ['erro'],
    limpar: [],
    setConsultaContratoCovidEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaConsultaContratoCovid = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaContratoCovidInicio())
        let serv = new ConsultaContratoCovidService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaConsultaContratoCovidSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaContratoCovidErro(error)))
    }
}

const buscaConsultaContratoCovidInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaContratoCovidErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaConsultaContratoCovidSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaContratoCovid.resultado,
        dataSincronizacaoDados: action.consultaContratoCovid.dataSincronizacaoDados,
        carregando: false,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaContratoCovidEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_CONTRATO_COVID_INICIO]: buscaConsultaContratoCovidInicio,
    [Types.BUSCA_CONSULTA_CONTRATO_COVID_ERRO]: buscaConsultaContratoCovidErro,
    [Types.BUSCA_CONSULTA_CONTRATO_COVID_SUCESSO]: buscaConsultaContratoCovidSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_CONTRATO_COVID_ESTADO_DT]: setConsultaContratoCovidEstadoDT,
})
